import { render, staticRenderFns } from "./DatasourceDsTabLineage.vue?vue&type=template&id=64f22d14&scoped=true&lang=pug"
import script from "./DatasourceDsTabLineage.vue?vue&type=script&lang=js"
export * from "./DatasourceDsTabLineage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64f22d14",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('64f22d14')) {
      api.createRecord('64f22d14', component.options)
    } else {
      api.reload('64f22d14', component.options)
    }
    module.hot.accept("./DatasourceDsTabLineage.vue?vue&type=template&id=64f22d14&scoped=true&lang=pug", function () {
      api.rerender('64f22d14', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/datastudio/components/DatasourceDsTabLineage.vue"
export default component.exports